import React, { useState } from 'react';
import { Card, Select, Button, message, Space, DatePicker } from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;

const ExportReports = () => {
    const [format, setFormat] = useState('CSV');
    const onExport = () => {
        message.success(`Report exported as ${format} (mocked)`);
    };
    return (
        <Card title="Export Billing Reports" style={{ maxWidth: 400, margin: '0 auto' }}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <RangePicker style={{ width: '100%' }} />
                <Select value={format} onChange={setFormat} style={{ width: '100%' }}>
                    <Option value="CSV">CSV</Option>
                    <Option value="PDF">PDF</Option>
                </Select>
                <Button type="primary" onClick={onExport} block>Export</Button>
            </Space>
        </Card>
    );
};
export default ExportReports; 